const chipServiceName = "/Chip";

export function chipService (http)  {
    return {
        savePersonnelChipInformationAsync :async (userProfileId, registererUserProfileId) => {
            const parameters = { 
                userProfileId, 
                registererUserProfileId
            };
            
            return await http.post(chipServiceName + '/SavePersonnelChipInformationAsync', parameters);
        },
        getChipInformationAsync :async (userProfileId) => {
            const parameters = { 
                userProfileId, 
            };
            
            return await http.post(chipServiceName + '/GetChipInformationAsync', parameters);
        },
        getTotalPersonnelAsync :async () => {           
            return await http.get(chipServiceName + '/GetTotalPersonnelAsync');
        },                
    }
}